
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.296 0l-7.284 10.485L13.722 0H0l21.012 30L42.018 0H28.296zm-7.284 27.204L3.081 1.605h5.385L21.012 19.65l12.54-18.045h5.385L21.012 27.204z","fill":"#fff"}})])
          )
        }
      }
    